export default __webpack_public_path__ + "static/customer_logo-0cebb9046f2d16e242b2ddba50e4d49c.png";